import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import type { UserJobPostsQueryMetadata as UserJobPostsQueryMetadata } from './types';

import { paginatedApiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { jobPostSchema } from './schemas';

const userJobPostsQueryOptions = (metadata: UserJobPostsQueryMetadata) =>
  queryOptions({
    queryKey: QueryKeys.jobPosts.index.user.metadata(metadata),
    queryFn: async () => {
      const { pagination } = metadata;

      const response = await fetchJson('/job-posts', {
        schema: paginatedApiResourceSchema(jobPostSchema.array()),
        params: {
          pagination: { pageIndex: pagination.pageIndex + 1, pageSize: pagination.pageSize },
          userId: metadata.userId,
        },
      });

      return response;
    },
    staleTime: 30 * 1000,
    gcTime: 2 * 60 * 1000,
    placeholderData: keepPreviousData,
  });

export const useUserJobPosts = (metadata: UserJobPostsQueryMetadata) => {
  return useQuery(userJobPostsQueryOptions(metadata));
};
